import type {
  Alert,
  Phone,
} from "@tandemdiabetes/sugarmate-api-react-client"

import { ContactCard } from "./ContactCard"
import styles from "./Contacts.module.scss"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.alerts.contacts."

interface Props {
  sugarmateAlert: Alert;
  phones: Phone[];
}

export function PendingContacts(props: Props) {
  const {
    sugarmateAlert,
    phones,
  } = props

  const polyglot = usePolyglot()

  if (!phones.length) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        {polyglot.t(`${polyglotPrefix}pending_heading`)}
      </div>
      {phones.map((phone) => (
        <ContactCard
          key={phone.id}
          phone={phone}
          sugarmateAlert={sugarmateAlert}
        />
      ))}
    </div>
  )
}
